import { render } from "./ViewPermissionsView.vue?vue&type=template&id=2b6ee142"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__